import { FlowBaseUrlEnum } from '@constants/app.constants';
import { Booking } from '@models/booking.models';
import { CoverGeniusCommitRequest } from '@models/requests/cover-genius-commit-request.model';
import { CoverGeniusQuoteResponse } from '@models/responses/cover-genius-quote-response.model';
import { createAction, props } from '@ngrx/store';

export const enum CoverGeniusActionTypes {
  requestQuote = '[coverGenius] REQUEST_QUOTE',
  requestQuoteSuccess = '[coverGenius] REQUEST_QUOTE_SUCCESS',
  selectPolicy = '[coverGenius] SELECT_POLICY',
  selectPolicySuccess = '[coverGenius] SELECT_POLICY_SUCCESS',
  clearQuote = '[coverGenius] CLEAR_QUOTE',
}

export const coverGeniusRequestQuote = createAction(
  CoverGeniusActionTypes.requestQuote,
  props<{
    bookingFlow: FlowBaseUrlEnum;
  }>(),
);

export const coverGeniusRequestQuoteSuccess = createAction(
  CoverGeniusActionTypes.requestQuoteSuccess,
  props<{
    payload: CoverGeniusQuoteResponse;
  }>(),
);

export const coverGeniusSelectPolicy = createAction(
  CoverGeniusActionTypes.selectPolicy,
  props<{ payload: CoverGeniusCommitRequest }>(),
);

export const coverGeniusSelectPolicySuccess = createAction(
  CoverGeniusActionTypes.selectPolicySuccess,
  props<{
    payload: Booking;
  }>(),
);

export const coverGeniusClearQuote = createAction(
  CoverGeniusActionTypes.clearQuote,
);
